export const GEOCOMM = 'geocomm';
export const WORLD = 'World';
